module.exports = __webpack_public_path__ + "static/img/qrcode-gzh.6064b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode-gzh.png
// module id = WjXw
// module chunks = 0